import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, Link, useLocation } from 'react-router-dom'; // Import useLocation here
import Login from './components/Login';
import TogglePage from './components/togglePage';
import DropdownPage from './components/dropdownPage';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import ProtectedRoute from './ProtectedRoute';
import { useAuth } from './AuthContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Ensure Router wraps the entire app
const App = () => {
  return (
    <Router> {/* Wrapping the entire app in Router */}
      <AppContent />
    </Router>
  );
};

const AppContent = () => {
  const { isAuthenticated, logout } = useAuth();
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  // Ensure useLocation is inside the Router context
  const location = useLocation(); 

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const [openLoginPrompt, setOpenLoginPrompt] = React.useState(false);

  const handleLoginPromptClose = () => {
    setOpenLoginPrompt(false);
  };

  const handleMenuItemClick = (menu) => {
    if (isAuthenticated) {
      if (menu === "fixtures") {
        window.location.href = "/dropdownpage";
      }
    } else {
      setOpenLoginPrompt(true);
    }
  };

  const theme = createTheme({
    typography: {
      fontFamily: '"Lato", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="fixed" sx={{ backgroundColor: 'black', borderBottom: "4px solid #F04A60" }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
            {/* Show Fixtures button only if on TogglePage */}
            {isAuthenticated && location.pathname !== '/dropdownpage' && (
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <Button
                  color="inherit"
                  component={Link}
                  to="/dropdownpage"
                  sx={{ mr: 2 }}
                >
                  Fixtures
                </Button>
              </Box>
            )}

            {/* Mobile View: Sandwich Menu (Only After Authentication) */}
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="menu"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
              >
                {isAuthenticated ? (
                  <Box>
                    <MenuItem component={Link} to="/dropdownpage" onClick={handleCloseNavMenu}>
                      FIXTURES
                    </MenuItem>
                    <MenuItem onClick={() => { handleCloseNavMenu(); logout(); }}>
                      LOGOUT
                    </MenuItem>
                  </Box>
                ) : (
                  <MenuItem onClick={handleMenuItemClick}>
                    Please Login First
                  </MenuItem>
                )}
              </Menu>
            </Box>

            {/* Center: Logo */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', flexGrow: 1, justifyContent: 'center' }}>
              <img
                src="/images/AE_SoftwareLogo_AECHECK_Lgt.png"
                alt="Logo"
                style={{ width: '15%' , height: '10%' ,marginLeft: isAuthenticated && location.pathname !== '/dropdownpage' ? 0 : '95px' }} 
                
              />
            </Box>

            {/* Right Side: Logout Button (Only After Authentication) */}
            {isAuthenticated && (
              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <Button color="inherit" onClick={logout}>
                  Logout
                </Button>
              </Box>
            )}

            {/* Mobile Right Side: Logo Only */}
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <img
                src="/images/AE_SoftwareLogo_AECHECK_LogoMark_Circle_Lgt.png"
                alt="Logo"
                style={{ width: '34px', height: '34px' }}
              />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Routes */}
      <Routes>
        <Route path="/" element={isAuthenticated ? <Navigate to="/dropdownpage" replace /> : <Login />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dropdownpage" element={<DropdownPage />} />
          <Route path="/togglepage" element={<TogglePage />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
};

export default App;
